import PropTypes from 'prop-types';

const TaxAuthorities = ({ color, size, ...props }) => (
    <svg viewBox="0 0 20 20" width={size} height={size} {...props}>
        <path
            d="M14.884 6.573a.75.75 0 0 1 1.233.853l-5.885 8.5a.752.752 0 0 1-1.147.104l-3.923-3.923a.75.75 0 0 1 1.06-1.06l3.288 3.287zM7.592 2.634a.5.5 0 0 1 .168.07l.071.059.059.071a.47.47 0 0 1 .079.26V4.67l1.477-.886a.47.47 0 0 1 .665.605l-.048.079a.5.5 0 0 1-.137.122l-.032.018-1.483.89 1.518.911a.47.47 0 0 1 .213.29l.013.09-.005.092a.47.47 0 0 1-.184.307.47.47 0 0 1-.439.064l-.01-.004-.06-.028-.012-.006-1.476-.888v1.58a.47.47 0 0 1-.377.46l-.092.008a.47.47 0 0 1-.469-.469V6.327l-1.477.888-.084.05-.01-.01a.44.44 0 0 1-.262.014.47.47 0 0 1-.235-.14l-.055-.074a.473.473 0 0 1 .164-.646l1.515-.91-1.515-.91a.47.47 0 0 1-.164-.644l.055-.074a.46.46 0 0 1 .42-.147q.093.015.17.061l1.478.886V3.094a.47.47 0 0 1 .469-.469z"
            fill={color}
        />
    </svg>
);

export default TaxAuthorities;

TaxAuthorities.propTypes = {
    color: PropTypes.string.isRequired,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
